var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTravelMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 339,
    viewBox: "0 0 239 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.52 86.5874C287.496 106.365 299.494 145.913 306.692 177.758C313.657 208.574 293.796 228.756 279.716 257.039C264.485 287.632 261.961 322.768 228.044 326.954C195.555 330.965 203.292 274.137 176.66 255.103C153.674 238.674 97.8359 250.587 85.5773 225.131C70.1192 193.032 40.1243 137.559 54.6393 105.022C70.2212 70.0941 128.1 103.755 165.652 96.5052C201.49 89.5868 232.48 64.477 261.52 86.5874Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.987 97.1644C280.405 114.994 291.222 150.647 297.711 179.354C303.99 207.135 286.086 225.329 273.393 250.825C259.663 278.405 257.388 310.079 226.811 313.853C197.522 317.468 204.496 266.239 180.487 249.079C159.765 234.268 109.427 245.007 98.3753 222.059C84.4393 193.121 57.398 143.112 70.483 113.78C84.5297 82.2934 136.708 112.639 170.562 106.104C202.869 99.8676 230.807 77.2317 256.987 97.1644Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.756 104.038C275.406 120.521 285.408 153.478 291.409 180.015C297.216 205.696 280.666 222.512 268.933 246.08C256.242 271.573 254.141 300.851 225.875 304.338C198.799 307.677 205.243 260.323 183.046 244.459C163.888 230.767 117.354 240.69 107.135 219.476C94.2503 192.726 69.2483 146.496 81.3426 119.384C94.3259 90.2792 142.564 118.334 173.86 112.295C203.727 106.533 229.552 85.6107 253.756 104.038Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.452 112.598C266.96 126.685 275.52 154.841 280.658 177.511C285.63 199.45 271.492 213.808 261.474 233.935C250.638 255.707 248.853 280.716 224.698 283.684C201.561 286.526 207.05 246.078 188.075 232.519C171.698 220.817 131.934 229.276 123.194 211.151C112.172 188.297 90.7889 148.798 101.115 125.644C112.2 100.787 153.434 124.769 180.177 119.622C205.699 114.711 227.761 96.8483 248.452 112.598Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.539 120.366C264.395 133.2 272.18 158.864 276.85 179.528C281.37 199.526 268.482 212.622 259.345 230.975C249.461 250.828 247.823 273.628 225.814 276.345C204.732 278.947 209.753 242.071 192.471 229.72C177.555 219.059 141.321 226.79 133.366 210.271C123.336 189.441 103.872 153.444 113.291 132.33C123.403 109.665 160.96 131.507 185.329 126.803C208.584 122.313 228.694 106.019 247.539 120.366Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.574 129.249C258.268 140.438 265.052 162.817 269.121 180.837C273.058 198.275 261.819 209.698 253.85 225.705C245.229 243.019 243.798 262.903 224.607 265.276C206.225 267.549 210.609 235.389 195.543 224.621C182.54 215.326 150.947 222.074 144.014 207.67C135.271 189.507 118.307 158.118 126.523 139.704C135.342 119.936 168.085 138.978 189.333 134.872C209.609 130.953 227.146 116.74 243.574 129.249Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.596 135.023C255.994 145.226 262.177 165.634 265.885 182.067C269.473 197.97 259.223 208.389 251.954 222.988C244.091 238.779 242.783 256.912 225.285 259.079C208.523 261.154 212.524 231.825 198.788 222.006C186.932 213.532 158.123 219.689 151.803 206.554C143.834 189.991 128.369 161.367 135.863 144.573C143.908 126.544 173.761 143.906 193.136 140.158C211.626 136.582 227.618 123.618 242.596 135.023Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.774 152.089C246.204 159.269 250.557 173.63 253.168 185.194C255.695 196.384 248.483 203.714 243.369 213.985C237.837 225.096 236.919 237.855 224.604 239.377C212.808 240.836 215.621 220.199 205.953 213.289C197.609 207.325 177.335 211.654 172.886 202.411C167.276 190.756 156.39 170.613 161.662 158.797C167.321 146.113 185.566 149.327 199.201 146.692C212.212 144.178 226.232 144.062 236.774 152.089Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.587 159.555C241.17 165.324 244.684 176.846 246.795 186.122C248.837 195.099 245.363 202.448 238.958 209.2C236.427 210.845 236.198 211.227 231.463 211.805C221.99 212.961 216.677 214.15 208.903 208.597C202.194 203.804 185.915 207.252 182.33 199.835C177.81 190.481 169.042 174.315 173.263 164.845C177.794 154.68 192.452 157.279 203.401 155.182C213.849 153.181 225.11 153.105 233.587 159.555Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.716 165.809C233.331 170.072 235.963 178.545 237.552 185.365C239.09 191.965 236.55 197.351 231.845 202.288C229.982 203.488 229.815 203.768 226.322 204.177C219.335 204.994 215.418 205.85 209.662 201.745C204.694 198.203 192.691 200.681 190.021 195.221C186.654 188.337 180.129 176.434 183.212 169.494C186.522 162.043 197.35 164.001 205.423 162.497C213.127 161.062 221.438 161.044 227.716 165.809Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.895 171.489C225.242 174.026 226.819 179.058 227.774 183.107C228.698 187.026 227.194 190.219 224.402 193.142C223.296 193.851 223.197 194.017 221.119 194.255C216.963 194.73 213.631 196.528 211.442 196.013C209.254 195.499 208.421 197.451 199.51 188.89C197.498 184.8 193.599 177.728 195.424 173.613C197.383 169.196 203.827 170.374 208.628 169.492C213.209 168.652 218.153 168.652 221.895 171.489Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.525 174.576C221.956 176.418 223.104 180.068 223.799 183.005C224.472 185.847 224.932 189.025 221.358 190.28C220.555 190.794 220.484 190.914 218.976 191.085C215.96 191.427 213.542 192.729 211.953 192.354C210.364 191.98 206.741 192.388 203.288 187.182C201.825 184.214 198.991 179.083 200.313 176.101C201.732 172.899 206.41 173.756 209.895 173.12C213.22 172.513 216.808 172.516 219.525 174.576Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTravelMonth);
export default __webpack_public_path__ + "static/media/Right-TravelMonth.4e788b520c38ff47154e7c03bc91fe4c.svg";
export { ForwardRef as ReactComponent };